export interface IMonth {
  month: string;
}
export interface IYear {
  year: string;
}
export interface ICountry {
  country: string;
}

const CountryList: ICountry[] = [
  {
    country: 'Afghanistan',
  },
  {
    country: 'Albania',
  },
  {
    country: 'United Kingdom',
  },
  {
    country: 'United States',
  },
  {
    country: 'Zambia',
  },
  {
    country: 'Zimbabwe',
  },
];
const MonthList: IMonth[] = [
  {
    month: '01',
  },
  {
    month: '02',
  },
  {
    month: '03',
  },
  {
    month: '04',
  },
  {
    month: '05',
  },
  {
    month: '06',
  },
  {
    month: '07',
  },
  {
    month: '08',
  },
  {
    month: '09',
  },
  {
    month: '10',
  },
  {
    month: '11',
  },
  {
    month: '12',
  },
];

const YearList: IYear[] = [
  {
    year: '2022',
  },
  {
    year: '2023',
  },
  {
    year: '2024',
  },
  {
    year: '2025',
  },
  {
    year: '2026',
  },
  {
    year: '2027',
  },
  {
    year: '2028',
  },
  {
    year: '2029',
  },
  {
    year: '2030',
  },
];

export default { CountryList, MonthList, YearList };
